import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'pdpo:ui-preference';

export type UiPreference = 'classic' | 'new';

function readStored(): UiPreference {
  if (typeof window === 'undefined') return 'classic';
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return raw === 'new' ? 'new' : 'classic';
}

export function setUiPreferenceStorage(pref: UiPreference): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, pref);
}

export function getUiPreferenceStorage(): UiPreference {
  return readStored();
}

export function useUiPreference(): [UiPreference, (next: UiPreference) => void] {
  const [pref, setPref] = useState<UiPreference>(readStored);

  const update = useCallback((next: UiPreference) => {
    setUiPreferenceStorage(next);
    setPref(next);
  }, []);

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key !== STORAGE_KEY) return;
      setPref(event.newValue === 'new' ? 'new' : 'classic');
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return [pref, update];
}
